import React, { useState } from 'react';
import '../../assets/styles/onboard.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer,  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import config from '../../config.js';
import { useNavigate } from 'react-router-dom';
import axios from "axios";

function Forgotpassword() {
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [verifyform, setVerifyform] = useState({ otp: ['', '', '', ''], password: '' });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };
    const handleVerifyOtp = async (e) => {
        e.preventDefault();
        const otp = verifyform.otp.join('');
        const password = verifyform.password;

        if (otp.length !== 4 || !password) {
            toast.info('Please enter a valid 4-digit OTP and password.');
            return;
        }

        setLoading(true);
        try {
            const response = await axios.post(`${config.apiBaseUrl}/admin/verifypassword`, { otp, password });
            if (response.data.error) {
                toast.error(response.data.message);
            } else {
                toast.success('Password updated successfully!');
                setTimeout(() => {
                 navigate('/')
                }, 2000);
            }
        } catch (error) {
            console.error(error);
            toast.error('An error occurred while updating the password.');
        } finally {
            setLoading(false);
        }
    };

    const handleOTPChange = (e, index) => {
        const value = e.target.value;
        if (/[^0-9]/.test(value)) return;
        const newOtp = [...verifyform.otp];
        newOtp[index] = value;
        setVerifyform({ ...verifyform, otp: newOtp });
    };


    return (
<div className="container-fluid ">
            <ToastContainer />
            <div className="row">
                <div className=" col-7">
                    <div className='onboard-container'></div>
                </div>
                <div className="col-5 logincontainediv">                         
                            <form className="logincontainer" onSubmit={handleVerifyOtp}>
                            <h2 className="signup-header">Verify OTP</h2>
                                <div>
                                    <p style={{ textAlign: 'center', fontSize: '12px' }}>
                                        Enter the 4-digit one-time password (OTP) we sent to your  Email
                                    </p>
                                </div>
                                <div className="otp-input-container mb-4">
                                    {verifyform.otp.map((digit, index) => (
                                        <input
                                            key={index}
                                            type="text"
                                            className="otp-input "
                                            id={`otp-${index}`}
                                            maxLength="1"
                                            value={digit}
                                            onChange={(e) => handleOTPChange(e, index)}
                                        />
                                    ))}
                                </div>

                                <div className="mb-4 password-input-container">
                                    <label htmlFor="password" className="form-label">Enter New Password</label>
                                    <input
                                        type={passwordVisible ? 'text' : 'password'}
                                        className=" form-style-cls"
                                        id="password"
                                        name="password"
                                        placeholder="Test@123"
                                        required
                                        value={verifyform.password}
                                        onChange={(e) => setVerifyform({ ...verifyform, password: e.target.value })}
                                    />
                                    <span className="confirm-password-toggle" onClick={togglePasswordVisibility}>
                                        <FontAwesomeIcon className="eyepassword" icon={passwordVisible ? faEyeSlash : faEye} />
                                    </span>
                                </div>
                                <button type="submit" className="btn btn-primary mt-5 signup-btn " disabled={loading}>
                                    {loading ? 'Please wait...' : 'Set Password'}
                                </button>

                               
                            </form>
                        </div>
                   </div>
              </div>
            
    );
}

export default Forgotpassword;
